module.exports = __webpack_public_path__ + "assets/whatsapp.8e9789b83617bc02f0cf971f4644470d.svg";


//////////////////
// WEBPACK FOOTER
// ./img/whatsapp.svg
// module id = 649
// module chunks = 0